import React from 'react'

import { Tabs } from 'antd'

import i18n from 'i18n'
import classNames from 'classnames'
import { isGlobal } from 'conf'

import OrgChartTree from 'pages/records/components/OrgChartTree'
import GroupList from 'pages/records/components/GroupList'
import UserList from 'pages/records/components/UserList'

import { safeboxClient } from 'myNet'
// import { getAvatarURL } from 'pages/records/components/helper'
import styles from './style.module.scss'

class SelectUser extends React.Component {
  state = {
    activeKey: 'orgchart',
    licenseEnforce: false,
    activeLicenseSet: null,
    // 응답 전에는 "누가 무자격인지" 를 모른다. 그 상태로 조직도를 렌더하면 라이센스 없는
    // 사용자도 선택할 수 있고, 서버는 공유 대상자의 라이센스를 검증하지 않으므로 그대로
    // 공유가 만들어진다. 그래서 조회가 끝날 때까지 조직도를 보여주지 않는다.
    licenseLoading: !isGlobal(),
  }

  changedEmailList = []

  changedUserList = []

  changedGroupIdList = []

  changedGroupList = []

  componentDidMount() {
    // KR(한국향 조직도)만: 라이센스 없는 사용자 선택 불가 표시용 active 집합 1회 조회.
    if (!isGlobal()) {
      this.fetchActiveLicenses()
    }
  }

  componentDidUpdate(/* prevProps, prevState */) {}

  componentWillUnmount() {}

  fetchActiveLicenses = async () => {
    try {
      const res = await safeboxClient.get('/v1/users/active-licenses')
      const view = res?.data?.data || {}
      // fail-open: enforce=false(비좌석제/bootstrap/flag OFF)면 전원 활성 유지
      if (view.enforce === true) {
        const ids = view.active_officenext_user_ids || []
        this.setState({
          licenseEnforce: true,
          activeLicenseSet: new Set(ids.map(String)),
        })
      }
    } catch (e) {
      // 조회 실패 → 전원 활성(enforce 미설정, 업무 마비 방지)
    } finally {
      // 성공·enforce false·실패 어느 경로로 끝나도 게이트를 반드시 해제한다.
      // 한 경로라도 빠뜨리면 조직도가 스피너에 영구히 갇힌다.
      this.setState({ licenseLoading: false })
    }
  }

  renderOrgChart = () => {
    const { defaultEmailList, excludeEmailList, onUserSelectChanged } = this.props
    const { licenseEnforce, activeLicenseSet, licenseLoading } = this.state

    const attrs = {
      defaultEmailList,
      excludeEmailList,
      licenseEnforce,
      activeLicenseSet,
      licenseLoading,
      onSelectChanged: (changedEmailList, changedUserList) => {
        this.changedEmailList = changedEmailList
        this.changedUserList = changedUserList

        if (onUserSelectChanged != null) {
          onUserSelectChanged(changedEmailList, changedUserList)
        }
      },
    }

    return <OrgChartTree {...attrs} />
  }

  fetchUserList = async () => {
    const res = await safeboxClient.get('/v1/users')
    this.setState({
      userList: res.data?.data,
    })
  }

  renderUserList = () => {
    const { defaultEmailList, excludeEmailList, onUserSelectChanged } = this.props
    const { userList } = this.state

    console.log(' --- userList : ', userList)

    const attrs = {
      defaultEmailList,
      excludeEmailList,
      onSelectChanged: (changedEmailList, changedUserList) => {
        this.changedEmailList = changedEmailList
        this.changedUserList = changedUserList

        if (onUserSelectChanged != null) {
          onUserSelectChanged(changedEmailList, changedUserList)
        }
      },
    }

    console.log(' ---UserList attrs : ', attrs)

    return <UserList {...attrs} />
  }

  renderGroups = () => {
    const { excludeGroupIds, onGroupSelectChanged } = this.props

    const attrs = {
      excludeGroupIds,
      onSelectChanged: (changedGroupIdList, changedGroupList) => {
        this.changedGroupIdList = changedGroupIdList
        this.changedGroupList = changedGroupList

        if (onGroupSelectChanged != null) {
          onGroupSelectChanged(changedGroupIdList, changedGroupList)
        }
      },
    }

    return <GroupList {...attrs} />
  }

  getTabItems = () => {
    const items = [
      {
        key: 'orgchart',
        label: isGlobal() ? i18n.t('chat.member.members') : i18n.t('record.select.users'),
        children: isGlobal() ? this.renderUserList() : this.renderOrgChart(),
      },
      {
        key: 'groups',
        label: i18n.t('record.select.groups'),
        children: this.renderGroups(),
      },
    ]

    return items
  }

  render() {
    const { userOnly } = this.props

    let elem = null

    if (userOnly === false) {
      const { activeKey } = this.state
      const items = this.getTabItems()

      const tabsAttrs = {
        items,
        activeKey,
        centered: true,
        onChange: (newActiveKey) => {
          // console.log(' --- activeKey ', activeKey);
          this.activeKey = newActiveKey

          this.setState({
            activeKey: this.activeKey,
          })
        },
      }
      elem = <Tabs {...tabsAttrs} />
    } else {
      elem = isGlobal() ? this.renderUserList() : this.renderOrgChart()
    }

    return <div className={classNames(styles.SelectUser)}>{elem}</div>
  }
}

export default SelectUser
